import { GoogleAnalyticsEventsService } from './../../../services/google-analytics-events.service';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent {

  @Input('pageOptions') pageOptions: any;
  @Input('rows') rows: number;
  @Input('pages') pages: any;
  @Input('page') page: number;
  @Input() pageName: string;

  @Output() nextPage: EventEmitter<any>;
  @Output() previousPage: EventEmitter<any>;
  @Output() goToPage: EventEmitter<any>;
  @Output() setRowsPerPage: EventEmitter<any>;
  @Output() lastPage: EventEmitter<any>;

  constructor(private googleAnalyticsService: GoogleAnalyticsEventsService) {
    this.nextPage = new EventEmitter();
    this.previousPage = new EventEmitter();
    this.goToPage = new EventEmitter();
    this.setRowsPerPage = new EventEmitter();
    this.lastPage = new EventEmitter();
  }

  onNextPage(event) {
    event.preventDefault();
    this.nextPage.emit(event);
    this.googleAnalyticsService.emitEvent((this.pageName + ' Pagination'), 'Pagination Click', 'Change Page');
  }

  onPreviousPage(event) {
    event.preventDefault();
    this.previousPage.emit(event);
    this.googleAnalyticsService.emitEvent((this.pageName + ' Pagination'), 'Pagination Click', 'Change Page');
  }

  onGoToPage(event, page) {
    event.preventDefault();
    this.goToPage.emit(page);
    this.googleAnalyticsService.emitEvent((this.pageName + ' Pagination'), 'Select Page', 'Go to Page');
  }

  onSetRowsPerPage(event, rows) {
    event.preventDefault();
    this.setRowsPerPage.emit(rows);
    this.googleAnalyticsService.emitEvent((this.pageName + ' Pagination'), 'Change Page Size', 'Set page size');
  }

  onLastPage(event) {
    event.preventDefault();
    this.lastPage.emit(event);
    this.googleAnalyticsService.emitEvent((this.pageName + ' Pagination'), 'Select Page', 'Go to Page');
  }

}
